/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_CancelInputs */



/**
* | output |
* | --- |
* | "Cancel final" |
*
* @param {League_Final_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_cancel = /** @type {((inputs?: League_Final_CancelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_CancelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar la final")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cancelar a final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla la finale")
	return /** @type {LocalizedString} */ ("Cancel final")
});